import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { app } from "../../Firebase/Firebaseapp";


export const options = {
  title: "All Categories and Number of Cars",
  pieHole: 0.4,
  is3D: false,
};

const fireStoreDb = getFirestore(app);


const PieChart = () => {


  const [Cars, setCars] = useState([])

  const allCars = () => {
    return getDocs(collection(fireStoreDb, 'CarDetails'));
  }

  useEffect(() => {
    allCars().then((cars) => setCars(cars.docs));
  }, [])

 
  const reducerResult = Cars.map((x) => x.data().BodyType).reduce((acc, curr) => {
    if (acc[curr]) {
      acc[curr]++
    } else {
      acc[curr] = 1
    }
    return acc
  }, [])

  const result = Object.entries(reducerResult).map(([key, value]) => [key, value]);



  
  const data = [
    ["Task", "Hours per Day"],
    ...[...result]
  ];

  console.log(data)



  return (


    <div className='w-[100%] lg:w-[49%] bg-white hover:scale-105 transition duration-300 shadow-xl rounded-lg '>

<Chart
      chartType="PieChart"
      width="100%"
      height="400px"
      data={data}
      options={options}
    />
    </div>
  )
}

export default PieChart

